/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function CommentThread({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M13.582 10.598a2.1 2.1 0 0 1-2.082 1.828H6.58l-2.488 2.038a.6.6 0 0 1-.98-.464v-1.574H3a2.1 2.1 0 0 1-2.1-2.1V5.5a2.1 2.1 0 0 1 2.002-2.098A2.1 2.1 0 0 1 5 1.4h8A2.6 2.6 0 0 1 15.6 4v4.5a2.1 2.1 0 0 1-2.018 2.098ZM3 4.6a.9.9 0 0 0-.9.9v4.826a.9.9 0 0 0 .9.9h.712a.6.6 0 0 1 .6.6v.907l1.535-1.258a1.1 1.1 0 0 1 .697-.249H11.5a.9.9 0 0 0 .9-.9V5.5a.9.9 0 0 0-.9-.9H3Zm1.105-1.2A.9.9 0 0 1 5 2.6h8A1.4 1.4 0 0 1 14.4 4v4.5a.9.9 0 0 1-.8.895V5.5a2.1 2.1 0 0 0-2.1-2.1H4.105Z" clipRule="evenodd" /></svg>;
}
;